var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "news f-b-c" },
    [
      _c("image-news", { attrs: { list: _vm.imgNewsList } }),
      _c("div", { staticClass: "tab-news f-column-b" }, [
        _c("div", { staticClass: "tab-head" }, [
          _c(
            "ul",
            { staticClass: "tabs flex" },
            _vm._l(_vm.menuTabs, function (menu) {
              return _c(
                "li",
                {
                  key: menu.code,
                  staticClass: "tabs-item",
                  class: { active: _vm.activeTab === menu.code },
                  on: {
                    click: function ($event) {
                      _vm.activeTab = menu.code
                    },
                  },
                },
                [_vm._v(_vm._s(menu.title))]
              )
            }),
            0
          ),
          _c(
            "a",
            {
              staticClass: "a-btn more-btn",
              attrs: { href: _vm.moreBtnUrl, target: "_blank" },
            },
            [_vm._v("更多 >")]
          ),
        ]),
        _c(
          "ul",
          { staticClass: "news-list" },
          _vm._l(_vm.dataList[_vm.activeTab], function (data) {
            return _c(
              "li",
              { key: data.id, staticClass: "news-item f-b-c" },
              [
                _c(
                  "Link",
                  {
                    staticClass: "f-b-c",
                    attrs: {
                      to: {
                        path: `/info/detail/${_vm.activeTab}`,
                        query: { id: data.id },
                      },
                      title: data.title,
                      target: "_blank",
                    },
                  },
                  [
                    _c("span", { staticClass: "text-cut" }, [
                      _vm._v(_vm._s(data.title)),
                    ]),
                    _c("span", { staticClass: "time fc99 pl-10" }, [
                      _vm._v(_vm._s(_vm._f("formatterDate")(data.releaseTime))),
                    ]),
                  ]
                ),
              ],
              1
            )
          }),
          0
        ),
      ]),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }